// helpers/rutaCamiones.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- CAMIONES ----

// GET: lista
export const getCamiones = async () => {
  const { data } = await API.get(p("camiones"), auth());
  // típicamente: { ok, camiones, cantidad }
  return data;
};

// GET: uno por id
export const getCamionById = async (id) => {
  const { data } = await API.get(p(`camiones/${id}`), auth());
  return data;
};

// POST: crear
export const postCamion = async (payload) => {
  const { data } = await API.post(p("camiones"), payload, auth());
  return data;
};

// PUT: actualizar
export const putCamion = async (id, payload) => {
  const { data } = await API.put(p(`camiones/${id}`), payload, auth());
  return data;
};

// DELETE: baja lógica
export const deleteCamion = async (id) => {
  const { data } = await API.delete(p(`camiones/${id}`), auth());
  return data;
};
